export function handleError(error) {
    var errorMessage = "<ol>";
    var errorsData = error.response.data.errors;
    for (var errorData in errorsData) {
        if(Object.prototype.hasOwnProperty.call(errorsData, errorData)) {
            for (var errorDataSub in errorsData['' + errorData]) {
                if (Object.prototype.hasOwnProperty.call(errorsData['' + errorData], errorDataSub)) {
                    errorMessage += "<li>"+error.response.data.errors[errorData][errorDataSub] + "</li>";
                }
            }
        }
    }
    errorMessage += "</ol>";
    return errorMessage;
}